// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".DialogProfileUserAttach__Component .modal-card {\n  height: 80vh;\n}\n.DialogProfileUserAttach__Component .DialogProfileUserAttach__Component__Loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n.DialogProfileUserAttach__Component .field {\n  margin-top: 40px;\n  width: 100%;\n}\n.error {\n  color: red;\n  font-size: 15px;\n}\n", ""]);
// Exports
module.exports = exports;
